import { render, staticRenderFns } from "./SaveBuildingPositionLacks.vue?vue&type=template&id=41a6cdd2&scoped=true"
import script from "./SaveBuildingPositionLacks.vue?vue&type=script&lang=js"
export * from "./SaveBuildingPositionLacks.vue?vue&type=script&lang=js"
import style0 from "./SaveBuildingPositionLacks.vue?vue&type=style&index=0&id=41a6cdd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41a6cdd2",
  null
  
)

export default component.exports